<template>
  <div class="teaching-schedule-paper-upload">
    <el-tabs v-model="gridKey">
      <el-tab-pane v-for="grid in grids"
                   :key="grid.value"
                   :name="grid.value"
                   :label="grid.label"
                   lazy>
        <TemplateDataGrid :ref="grid.value"
                          :gridId="grid.value"
                          v-bind="gridParams"></TemplateDataGrid>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../../../templates/TemplateDataGrid'
export default {
  name: 'TeachingSchedulePaperUpload',
  components: {
    TemplateDataGrid
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      grids: [{
        value: 'PeTchSchedulePaperSubmit',
        label: '已提交学生'
      }, {
        value: 'PeTchSchedulePaperUnSubmit',
        label: '未提交学生'
      }],
      gridKey: ''
    }
  },
  computed: {
    gridParams () {
      return this.$extend({
        paperId: this.rowData.id
      }, this.extraParams)
    }
  },
  created () {
    this.gridKey = this.grids[0].value
  },
  methods: {
    reloadGridData () {
      if (this.visible) {
        let gridKey = this.gridKey
        if (gridKey) {
          let grids = this.$refs[gridKey]
          if (grids && grids.length) {
            grids[0].loadGridData()
          }
        }
      }
    }
  },
  watch: {
    visible: function () {
      this.reloadGridData()
    },
    gridKey: function () {
      this.reloadGridData()
    }
  }
}
</script>

<style lang="scss">
  .teaching-schedule-paper-upload {
    width: 760px;
    max-width: 100%;
    height: 100%;
    .el-tabs {
      position: relative;
      height: 100%;
      & > .el-tabs__header {
        padding-left: 15px;
        padding-right: 15px;
        background-color: #fafafa;
        margin-bottom: 0;
        .el-tabs__nav-wrap {
          &:after {
            display: none;
          }
          .el-tabs__nav-scroll {
            .el-tabs__nav {
              .el-tabs__item {
                height: 40px;
                font-size: 12px;
                line-height: 40px;
              }
            }
          }
        }
      }
      & > .el-tabs__content {
        position: absolute;
        left: 0;
        top: 40px;
        right: 0;
        bottom: 0;
        .el-tab-pane {
          height: 100%;
        }
      }
    }
  }
</style>
